/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpprofile_Deals_Empty2Inputs */

const en_coinvestments_insights_lpprofile_deals_empty2 = /** @type {(inputs: Coinvestments_Insights_Lpprofile_Deals_Empty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No deal activity`)
};

/**
* | output |
* | --- |
* | "No deal activity" |
*
* @param {Coinvestments_Insights_Lpprofile_Deals_Empty2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpprofile_deals_empty2 = /** @type {((inputs?: Coinvestments_Insights_Lpprofile_Deals_Empty2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpprofile_Deals_Empty2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpprofile_deals_empty2(inputs)
});
export { coinvestments_insights_lpprofile_deals_empty2 as "coInvestments_insights_lpProfile_deals_empty" }